import { KnownBusinessEntityRentalDispenseItem } from "@/models/known-business-entity-rental-dispense-item.model.ts"
import { AbstractKnownBusinessEntityAdministrativeItemController } from "@/controllers/model-controllers/abstract/abstract-known-business-entity-administrative-item-controller.ts"
import { type IKnownBusinessEntityRentalDispenseItem } from "@/interfaces/api/known-business-entity-rental-dispense-item.interface.ts"
import { KnownBusinessEntityRentalDispenseItemRepository } from "@/repositories/known-business-entity-rental-dispense-item.repository.ts"
import { useKnownBusinessEntitiesRentalDispenseItemsStore } from "@/store/known-business-entities-rental-dispense-items.store.ts"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export class KnownBusinessEntityRentalDispenseItemController extends AbstractKnownBusinessEntityAdministrativeItemController<
  KnownBusinessEntityRentalDispenseItem,
  IKnownBusinessEntityRentalDispenseItem,
  KnownBusinessEntityRentalDispenseItemRepository
> {
  constructor() {
    const knownBusinessEntitiesRentalDispenseItemsStore =
      useKnownBusinessEntitiesRentalDispenseItemsStore()
    const { knownBusinessEntitiesRentalDispenseItems } = storeToRefs(
      knownBusinessEntitiesRentalDispenseItemsStore
    )
    const storeFunctionsConfig = {
      collection: knownBusinessEntitiesRentalDispenseItems
    }

    super(
      KnownBusinessEntityRentalDispenseItem,
      storeFunctionsConfig,
      new KnownBusinessEntityRentalDispenseItemRepository()
    )
    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      KnownBusinessEntityRentalDispenseItem,
      knownBusinessEntitiesRentalDispenseItems
    )
  }
}
